<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row :gutter="24">
        <el-form-item label="产品名称" >
          <el-input
              v-model="serchParams.name"
              class="mb10"
              style="width: 240px"
              placeholder="请输入产品名称"
              clearable
          />
        </el-form-item>
        <el-form-item label="货品编码" >
          <el-input
              v-model="serchParams.goodsCode"
              class="mb10"
              style="width: 240px"
              placeholder="请输入货品编码"
              clearable
          />
        </el-form-item>
        <el-form-item label="产品类别" class="ml10">
          <el-select class="main-select-tree" ref="selectTree" clearable @clear="setValueNull"
                     v-model="parentName" style="width: 300px;" name='option 1'>
            <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.id" :key="item.label"
                       style="display: none;"/>

            <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps'
                     highlight-current @node-click="handleNodeClick" :expand-on-click-node="expandOnClickNode"/>
          </el-select>
        </el-form-item>
        <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>

    <div class="d-flex" style="margin-bottom: 20px">
      <el-button class="ma" type="primary" @click="handleAddPageClass('add')">+添加产品</el-button>
    </div>

    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border>
      <el-table-column
          prop="name"
          align="center"
          label="名称"
      />
      <el-table-column
          prop="categoryName"
          align="center"
          label="所属类别"
      />
      <el-table-column
          prop="busName"
          align="center"
          label="商家名称"
      >
        <template slot-scope="scope">
          {{ scope.row.busName || '--' }}
        </template>
      </el-table-column>
      <el-table-column
          prop="goodsCode"
          align="center"
          label="货品编码"
      >
        <template slot-scope="scope">
          {{ scope.row.goodsCode || '--' }}
        </template>
      </el-table-column>
      <el-table-column
          prop="specCode"
          align="center"
          label="规格码"
      >
        <template slot-scope="scope">
          {{ scope.row.specCode || '--' }}
        </template>
      </el-table-column>
      <el-table-column
          prop="specName"
          align="center"
          label="规格名称"
      >
        <template slot-scope="scope">
          {{ scope.row.specName || '--' }}
        </template>
      </el-table-column>
      <el-table-column
          prop="sort"
          align="center"
          label="排序"
      >
      </el-table-column>
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editCustomer(scope.row)">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消"
                         @confirm="delPageClass(scope.row)" icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>
          </el-popconfirm>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消"
                         @confirm="enabledClass(scope.row)" icon="el-icon-info" icon-color="red" :title="`确定要${scope.row.enabled?'停用':'启用'}该产品吗？`">
            <el-button slot="reference" class="ml10" :class="scope.row.enabled?'text-color-red':'text-color-green'" type="text">{{scope.row.enabled?'停用':'启用'}}</el-button>
          </el-popconfirm>

        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          class=""
          :total="total"
          :pager-count="5"
      />
    </div>


    <!-- <commonTable
      :tableData="tableData"
      :total="total"

      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:table>
        <el-table-column
          prop="name"
          align="center"
          label="名称"
        />
        <el-table-column
            prop="sort"
            align="center"
            label="排序"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
        />
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editCustomer(scope.row)">编辑</el-button>
            <customPopconfirm confirm-button-text="确定" k cancel-button-text="取消"
                              @confirm="delPageClass(scope.row)" icon="el-icon-info" icon-color="red" title="确定要删除吗？">
              <el-button slot="reference" class="ml10" style="color: #fd634e" type="text" >删除</el-button>
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable> -->

    <NewAddPageClassDialog ref="addPageClassDialog" @getList="getList"></NewAddPageClassDialog>
  </div>
</template>

<script>
import AddPageClassDialog from './components/AddPageClassDialog'
import NewAddPageClassDialog from "@/pages/proClass/components/NewAddPageClassDialog.vue";
// import commonTable from "@/components/common/commonTable";
// import customPopconfirm from "@/components/common/customPopconfirm";
import {deleteCustomPageClass, pageClassList, noPage, fetchClassPage,fetchEnableClass} from '@/api/customPageClass.js'
import {selectAllCategory} from "@/api/productCategory";

export default {
  components: {
    // commonTable,
    // AddPageClassDialog,
    NewAddPageClassDialog
    // customPopconfirm
  },
  props: {
    classType: {
      default: 0
    }
  },
  data() {
    return {
      name: null,
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      parentName: '',
      treeProps: {
        children: 'children',
        label: 'name'
      },
      expandOnClickNode: false,
      classList: [],
      categoryId: '',
      serchParams:{
        name:'',
        categoryId:'',
        goodsCode:''
      }
    };
  },
  created() {
    this.getList()
    this.getCategorys()
  },
  methods: {
    enabledClass(row){
      fetchEnableClass({id:row.id}).then(res=>{
          this.$message.success("操作成功")
          this.getList()
      })
    },
    resetSearch(){
      this.serchParams.name = ''
      this.serchParams.categoryId = ''
      this.parentName = ''
      this.serchParams.goodsCode = ''
      this.pageNum = 1
      this.getList()
    },
    getCategorys() {
      selectAllCategory().then(res => {
        this.classList = res.data
      })
    },
    handleNodeClick(node) {
      this.serchParams.categoryId = node.id
      this.parentName = node.fullName
      this.$refs.selectTree.blur();
    },
    setValueNull() {
      this.ruleForm.parentId = '';
      this.parentName = ''
    },
    optionData(array, result = []) {
      array.forEach(item => {
        result.push({
          label: item.fullName,
          value: item.id
        })
        if (item.children && item.children.length !== 0) {
          this.optionData(item.children, result)
        }
      })
      return JSON.parse(JSON.stringify(result))
    },
    getCustomer() {
      this.getList()
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddPageClass(type, id) {
      this.$refs.addPageClassDialog.openDialog(type, id, this.classType)
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: this.classType,
      }
      Object.assign(params, this.serchParams)
      fetchClassPage(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    editCustomer(data) {
      this.$refs.addPageClassDialog.openDialog('edit', data, this.classType)
    },
    delPageClass(data) {
      console.log(data)
      deleteCustomPageClass(data.id).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.getList()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },
    lookImg(row) {
      this.$router.push({
        path: '/classImgList', query: {
          id: row.id,
          name: row.name,
        },
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}

.pageBox {
  display: flex;
  justify-content: flex-end;
}
.text-color-red{
  color: #fd634e;
}
.text-color-green{
  color: #74d7d5;
}
</style>

